// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"618":"ca366489c7cd3026b1d2","944":"5a7531df74110bfa45b5","999":"a5da7872b9898c5e6d2c"}[chunkId] + ".js";
};